module.exports = __webpack_public_path__ + "static/media/Hero_Story_Desktop.770578ce.jpg";